import(/* webpackMode: "eager" */ "/home/raad/raad-dojo-next-release3/src/app/global-error.jsx");
